import React from 'react';
import { Box, Card, Divider, PaperProps } from '@mui/material';

import { Typography, CardContent, CardHeader } from '@occc-app/design-system';

interface IFormCardLayoutProps {
  children?: React.ReactNode;
  title?: string;
  action?: React.ReactElement;
  rootProps?: PaperProps;
}

export const FormCardLayout: React.FC<IFormCardLayoutProps> = ({
  title,
  action,
  rootProps,
  children,
}) => {
  return (
    <Card elevation={0} {...rootProps}>
      {title && (
        <CardHeader
          title={
            <Typography variant='h6' component='h4'>
              {title}
            </Typography>
          }
        />
      )}

      <CardContent sx={{ p: 0 }}>
        {children}
        {action ? (
          <>
            <Divider />
            <Box display='flex' justifyContent='center' mx='auto' mt={1}>
              {action}
            </Box>
          </>
        ) : null}
      </CardContent>
    </Card>
  );
};
